import { render, staticRenderFns } from "./scrollList.vue?vue&type=template&id=c41dbdde"
import script from "./scrollList.vue?vue&type=script&lang=js"
export * from "./scrollList.vue?vue&type=script&lang=js"
import style0 from "./scrollList.vue?vue&type=style&index=0&id=c41dbdde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports